import gql from 'graphql-tag';

// Load the complete, server-scoped filter sets: creating an "all" selection must
// include every matching docket, rather than just the first picker page.
export const GET_PLANNING_ROUTES = gql`
	query PlanningRoutes {
		getRoutes(sortBy: "name", sortDirection: 1) {
			items {
				id
				name
				driver { id }
				defaultStartLocation { id name }
				defaultEndLocation { id name }
				warehouse { id name }
				returnWarehouse { id name }
			}
		}
	}
`;

export const GET_PLANNING_MACHINES = gql`
	query PlanningMachines($filter: MachinePageFilter) {
		getMachines(sortBy: "assetId", sortDirection: 1, filter: $filter) {
			items {
				id
				assetId
				type
				location { id name }
				place { id name }
			}
		}
	}
`;

export const GET_PLANNING_USERS = gql`
	query PlanningUsers($page: Int!, $perPage: Int!, $filter: UserPageFilter) {
		getUsers(page: $page, perPage: $perPage, sortBy: "firstname", sortDirection: 1, filter: $filter) {
			items { id firstname lastname username }
			count
		}
	}
`;

export const GET_PLANNING_WAREHOUSES = gql`
	query PlanningWarehouses($page: Int!, $perPage: Int!, $filter: WarehousePageFilter) {
		getWarehouses(page: $page, perPage: $perPage, sortBy: "name", sortDirection: 1, filter: $filter) {
			items { id name }
			count
		}
	}
`;

export const GET_PLANNING_LOCATIONS = gql`
	query PlanningLocations($page: Int!, $perPage: Int!, $filter: LocationPageFilter) {
		getLocations(page: $page, perPage: $perPage, sortBy: "name", sortDirection: 1, filter: $filter) {
			items { id name }
			count
		}
	}
`;
